var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 2.1001H2.4C1.90294 2.1001 1.5 2.50304 1.5 3.0001V9.93994L2.23298 9.22341C3.43766 8.04575 5.36234 8.04575 6.56702 9.22341L7.3 9.93994V3.0001C7.3 2.50304 6.89706 2.1001 6.4 2.1001ZM2.4 0.600098C1.07452 0.600098 0 1.67461 0 3.0001V11.6031C0 12.3115 0.852697 12.6704 1.35923 12.1752L3.28154 10.296C3.90331 9.68821 4.89669 9.68821 5.51846 10.296L7.44077 12.1752C7.9473 12.6704 8.8 12.3115 8.8 11.6031V3.0001C8.8 1.67461 7.72548 0.600098 6.4 0.600098H2.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkOutlined);
export default __webpack_public_path__ + "static/media/bookmark-outlined.4c854fc4f12db3e651453f896044da35.svg";
export { ForwardRef as ReactComponent };